var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadUnlock = function SvgFadUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192 136.01c0-4.424-3.59-8.01-8.007-8.01H72.007A8.004 8.004 0 0 0 64 136.01v84.98c0 4.424 3.59 8.01 8.007 8.01h111.986a8.004 8.004 0 0 0 8.007-8.01v-84.98z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 148.316c0-2.384-1.547-4.316-3.46-4.316H83.46c-1.911 0-3.46 1.936-3.46 4.316v60.368c0 2.384 1.547 4.316 3.46 4.316h89.08c1.911 0 3.46-1.936 3.46-4.316v-60.368z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.68 67.531c-14.533-26.083-34.866-41.328-62.114-27.505l-12.318 6.533c-24.975 13.28-24.682 39.82-10.153 65.895l17.307 31.062c3.099-1.572 14.764-7.171 14.625-7.42a91007.454 91007.454 0 0 1-15.348-27.546l-1.96-3.515c-4.472-8.028-19.596-31.046 5.5-43.756l11.12-5.508c20.097-10.195 28.497.812 38.728 19.173l1.96 3.516c8.524 15.3 14.397 28.028 15.348 27.546l14.612-7.413L158.68 67.53z",
    fill: "#000"
  }))));
};
export { SvgFadUnlock as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-unlock.b2f28fc3.svg";